"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ClusterType = exports.ClusterItemType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _product = require("@nucleo/product");
function cov_8fviczumu() {
  var path = "/codebuild/output/src2021135794/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/section/lib/type.js";
  var hash = "de7c969d94206852395234bb59fb9c291990d9d2";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src2021135794/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/section/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 31
        },
        end: {
          line: 7,
          column: 2
        }
      },
      "1": {
        start: {
          line: 9,
          column: 27
        },
        end: {
          line: 15,
          column: 2
        }
      },
      "2": {
        start: {
          line: 17,
          column: 20
        },
        end: {
          line: 33,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "de7c969d94206852395234bb59fb9c291990d9d2"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_8fviczumu = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_8fviczumu();
var ClusterItemType = exports.ClusterItemType = (cov_8fviczumu().s[0]++, _propTypes.default.shape({
  product: _product.ProductType,
  displayAs: _propTypes.default.oneOf(['PRODUCT', 'PERFORMANCE', 'TOUR'])
}));
var ClusterType = exports.ClusterType = (cov_8fviczumu().s[1]++, _propTypes.default.shape({
  name: _propTypes.default.string,
  code: _propTypes.default.string,
  rawName: _propTypes.default.objectOf(_propTypes.default.string),
  items: _propTypes.default.arrayOf(ClusterItemType),
  quantity: _propTypes.default.number
}));
var SectionType = (cov_8fviczumu().s[2]++, _propTypes.default.shape({
  code: _propTypes.default.string,
  name: _propTypes.default.string,
  rawName: _propTypes.default.objectOf(_propTypes.default.string),
  layout: _propTypes.default.oneOf(['CARD', 'SLIDER', 'DEFAULT', 'PAGINATED_LIST']),
  columns: _propTypes.default.number,
  randomOrder: _propTypes.default.bool,
  classifyBy: _propTypes.default.oneOf(['FAMILY', 'CLUSTER', 'DATE', 'NONE', 'DAY']),
  clusters: _propTypes.default.arrayOf(ClusterType),
  aspectRatio: _propTypes.default.string,
  maxInSlider: _propTypes.default.number,
  maxItemPerPage: _propTypes.default.number,
  displayPriceInfo: _propTypes.default.bool,
  displayDescPreview: _propTypes.default.bool,
  displayActionBtn: _propTypes.default.bool,
  sortByDate: _propTypes.default.bool
}));
var _default = exports.default = SectionType;